<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    class="app-accent-lighter"
    d="M10.25 12.9106C10.25 10.1492 12.4886 7.91064 15.25 7.91064H48.8335C51.595 7.91064 53.8335 10.1492 53.8335 12.9106V66.25C53.8335 69.0114 51.595 71.25 48.8335 71.25H15.25C12.4886 71.25 10.25 69.0114 10.25 66.25V12.9106Z"
  />
  <g clip-path="url(#clip0)">
    <path
      d="M59.6158 16.5459L59.6126 16.5427L46.496 2.92685L46.494 2.92473L46.2043 2.62402H19.1422C18.1266 2.62517 17.1529 3.04449 16.4347 3.78999C15.7165 4.53548 15.3126 5.54626 15.3115 6.60055V61.9868C15.3126 63.0411 15.7165 64.0519 16.4347 64.7974C17.1529 65.5429 18.1266 65.9622 19.1422 65.9633H56.0767C57.0923 65.9622 58.066 65.5429 58.7842 64.7974C59.5023 64.0519 59.9063 63.0411 59.9074 61.9868V16.8487L59.6158 16.5459ZM46.7857 6.13787L56.5381 16.2615L46.7857 16.3289L46.7857 6.13787ZM57.9242 61.9868C57.9237 62.4953 57.7289 62.9829 57.3826 63.3424C57.0362 63.702 56.5665 63.9042 56.0767 63.9047H19.1422C18.6524 63.9042 18.1827 63.702 17.8363 63.3424C17.4899 62.9829 17.2951 62.4953 17.2947 61.9868V6.60057C17.2951 6.09206 17.4899 5.60452 17.8363 5.24495C18.1827 4.88538 18.6524 4.68318 19.1422 4.68271H44.8025V17.3667C44.8023 17.5019 44.8278 17.6359 44.8775 17.7609C44.9273 17.8859 45.0003 17.9994 45.0924 18.0951C45.1845 18.1907 45.2939 18.2665 45.4144 18.3182C45.5348 18.3698 45.6638 18.3962 45.7941 18.396H45.8006L57.9242 18.3108V61.9868Z"
      fill="#484B4D"
    />
    <line
      x1="21.7501"
      y1="56.25"
      x2="32.2501"
      y2="56.25"
      stroke="#484B4D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.0001 51L29.0001 45.5L43.5001 31L48.0001 35.5L33.5001 50L28.0001 51Z"
      fill="white"
    />
    <path
      d="M43.6434 30.4405C43.574 30.3719 43.4804 30.3335 43.3829 30.3335C43.2854 30.3335 43.1918 30.3719 43.1224 30.4405L40.4566 33.1071L28.8069 44.7601C28.7767 44.7907 28.7528 44.827 28.7367 44.8668L28.7245 44.8959C28.7208 44.91 28.7159 44.9238 28.71 44.9371L27.3407 51.2206C27.3285 51.2751 27.3289 51.3316 27.3419 51.3859C27.3549 51.4402 27.3801 51.4909 27.4157 51.5339C27.4512 51.577 27.4961 51.6113 27.547 51.6343C27.5979 51.6573 27.6533 51.6684 27.7091 51.6667H27.7867L34.0634 50.3067C34.0768 50.3008 34.0906 50.2959 34.1046 50.2921H34.1337C34.1735 50.2759 34.2098 50.2521 34.2404 50.2218L45.8924 38.5494L48.5582 35.8828C48.6268 35.8134 48.6652 35.7197 48.6652 35.6222C48.6652 35.5246 48.6268 35.431 48.5582 35.3616L43.6434 30.4405ZM28.1889 50.8182L29.2795 45.7565L33.2492 49.7273L28.1889 50.8182ZM33.9859 49.4194L29.5873 45.0195L40.7135 33.8901L45.1121 38.29L33.9859 49.4194ZM45.6307 37.7688L41.2345 33.3713L43.3817 31.2211L47.7803 35.621L45.6307 37.7688Z"
      fill="#484B4D"
      stroke="#484B4D"
      stroke-width="0.8"
    />
  </g>
  <defs>
    <clipPath id="clip0">
      <rect width="45.7627" height="64.4704" fill="white" transform="translate(14.4874 2.25)" />
    </clipPath>
  </defs>
</svg>
